module.exports = __webpack_public_path__ + "static/media/lazyaz_app6.f601bdbc.jpg";